export interface FeatureFlagsState {
  demoActive?: boolean
  clientReady?: boolean
  cspUpsell?: {
    isEnabled?: boolean
    cspUpsellWithFreeTrial?: boolean
    cspUpsellShowInterstitial?: boolean
  }
  authModalExpFlag?: boolean
  paritalPlagCheckDisabled?: boolean
}

export enum EnableCLSandboxValues {
  true = 'true',
  false = 'false',
}

export enum UpsellVariation {
  control = 'control',
  var1 = 'variation-1',
  var2 = 'variation-2',
  var3 = 'variation-3',
}

export enum PlanId {
  cwft = 'cwft',
  cwnft = 'cwnft',
  csp = 'csp',
}

export const PLAN_ID = 'planId'



// WEBPACK FOOTER //
// ./src/state/featureFlags/types.ts